import { Component,Input, OnInit } from '@angular/core';
import { SicotService } from '../../sicot.service';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-esito-uvm',
    imports: [CommonModule, MatCardModule],
    templateUrl: './esito-uvm.component.html',
    styleUrl: './esito-uvm.component.css'
})
export class EsitoUvmComponent implements OnInit {

  API_ENDPOINT_COT_SERVICE = environment.API_ENDPOINT_COT_SERVICE;


  data:any | undefined;

  ngOnInit(): void {
    this.getRichiesta(this.idRichiesta)
    .subscribe((richiesta: any) => {

      this.data = richiesta;
    })
  }

  @Input() idRichiesta: any;


  constructor(private siCotService:SicotService,private http:HttpClient){

  }

  getRichiesta(id: number): Observable<any> {
    return this.http
      .get<any>(this.API_ENDPOINT_COT_SERVICE + `/esito-uvm/${id}`)
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }
}